export default __webpack_public_path__ + "static/media/404-error.ed023e2b.png";